/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Start_Time_Only_AriaInputs */

const en_timing_sync_start_time_only_aria = /** @type {(inputs: Timing_Sync_Start_Time_Only_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply compensation to start time only`)
};

const fr_timing_sync_start_time_only_aria = /** @type {(inputs: Timing_Sync_Start_Time_Only_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer la compensation uniquement a l'heure de debut`)
};

const de_timing_sync_start_time_only_aria = /** @type {(inputs: Timing_Sync_Start_Time_Only_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Vergütung gilt nur für den Arbeitsbeginn.`)
};

const it_timing_sync_start_time_only_aria = /** @type {(inputs: Timing_Sync_Start_Time_Only_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applicare la compensazione solo all'orario di inizio`)
};

const ru_timing_sync_start_time_only_aria = /** @type {(inputs: Timing_Sync_Start_Time_Only_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компенсация применяется только к времени начала работы.`)
};

const es_timing_sync_start_time_only_aria = /** @type {(inputs: Timing_Sync_Start_Time_Only_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar compensación solo a la hora de inicio`)
};

const zh_cn2_timing_sync_start_time_only_aria = /** @type {(inputs: Timing_Sync_Start_Time_Only_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`补偿仅适用于开始时间。`)
};

const ja_timing_sync_start_time_only_aria = /** @type {(inputs: Timing_Sync_Start_Time_Only_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間のみに補正を適用する`)
};

const hi_timing_sync_start_time_only_aria = /** @type {(inputs: Timing_Sync_Start_Time_Only_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुआवजा केवल प्रारंभ समय पर लागू करें`)
};

const pt_pt2_timing_sync_start_time_only_aria = /** @type {(inputs: Timing_Sync_Start_Time_Only_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar a compensação apenas ao tempo de início.`)
};

/**
* | output |
* | --- |
* | "Apply compensation to start time only" |
*
* @param {Timing_Sync_Start_Time_Only_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_start_time_only_aria = /** @type {((inputs?: Timing_Sync_Start_Time_Only_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Start_Time_Only_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_start_time_only_aria(inputs)
	if (locale === "de") return de_timing_sync_start_time_only_aria(inputs)
	if (locale === "it") return it_timing_sync_start_time_only_aria(inputs)
	if (locale === "ru") return ru_timing_sync_start_time_only_aria(inputs)
	if (locale === "es") return es_timing_sync_start_time_only_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_start_time_only_aria(inputs)
	if (locale === "ja") return ja_timing_sync_start_time_only_aria(inputs)
	if (locale === "hi") return hi_timing_sync_start_time_only_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_start_time_only_aria(inputs)
	return en_timing_sync_start_time_only_aria(inputs)
});